module.exports = __webpack_public_path__ + "img/reviewIcon.47bf9ce6.svg";